import { t } from "@/i18n-js/instance";
import { Filter, InputFilter } from "@circle-react-shared/Filter";

interface SpaceGroupFilterProps {
  onChange: (value: string) => void;
  value: string;
}

export const SpaceGroupFilter = ({
  value,
  onChange,
}: SpaceGroupFilterProps) => (
  <Filter
    chip={t("settings.community_bot.knowledge.filters.space_group_chip")}
    title={t("settings.community_bot.knowledge.filters.space_group_title")}
    selectedText={value}
    onApply={val => onChange(val || "")}
    isInitialOpen={false}
    shouldShowRemoveButton
  >
    <InputFilter
      name="space-group-filter"
      placeholder={t(
        "settings.community_bot.knowledge.filters.space_group_search_placeholder",
      )}
      defaultValue={value}
    />
  </Filter>
);
